var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 8.25C14.071 8.25016 15.7501 9.92903 15.7501 12C15.7501 14.071 14.071 15.7498 12.0001 15.75C9.92904 15.75 8.25008 14.071 8.25008 12C8.25008 9.92895 9.92904 8.25004 12.0001 8.25ZM12.0001 9.75C10.7575 9.75004 9.75008 10.7574 9.75008 12C9.75008 13.2426 10.7575 14.25 12.0001 14.25C13.2426 14.2498 14.2501 13.2425 14.2501 12C14.2501 10.7575 13.2426 9.75016 12.0001 9.75Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 3.75C16.9711 3.7502 21.1868 6.97284 22.6759 11.4404C22.7962 11.8015 22.796 12.1926 22.6759 12.5537C21.1885 17.0244 16.9714 20.2499 11.9991 20.25C7.0289 20.25 2.81344 17.0272 1.3243 12.5596C1.20397 12.1985 1.20321 11.8074 1.32333 11.4463C2.81067 6.97549 7.0286 3.75003 12.0011 3.75ZM12.0011 5.25C7.69377 5.25003 4.03671 8.04368 2.74715 11.9199C2.72939 11.9733 2.7294 12.0315 2.74715 12.085C4.03822 15.9586 7.6937 18.75 11.9991 18.75C16.3064 18.7499 19.9635 15.9564 21.253 12.0801C21.2708 12.0267 21.2707 11.9684 21.253 11.915C19.962 8.04157 16.3063 5.2502 12.0011 5.25Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.635070fa472f3d2d1693f828313039b8.svg";
export { ForwardRef as ReactComponent };